var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5C1 15.3281 1.67187 16 2.5 16H11.5C12.3281 16 13 15.3281 13 14.5V4H1V14.5ZM9.5 6.5C9.5 6.22266 9.72266 6 10 6C10.2773 6 10.5 6.22266 10.5 6.5V13.5C10.5 13.7773 10.2773 14 10 14C9.72266 14 9.5 13.7773 9.5 13.5V6.5ZM6.5 6.5C6.5 6.22266 6.72266 6 7 6C7.27734 6 7.5 6.22266 7.5 6.5V13.5C7.5 13.7773 7.27734 14 7 14C6.72266 14 6.5 13.7773 6.5 13.5V6.5ZM3.5 6.5C3.5 6.22266 3.72266 6 4 6C4.27734 6 4.5 6.22266 4.5 6.5V13.5C4.5 13.7773 4.27734 14 4 14C3.72266 14 3.5 13.7773 3.5 13.5V6.5ZM13.5 1H10L9.63819 0.276375C9.55353 0.107 9.38037 0 9.19097 0H4.80903C4.61962 0 4.44653 0.107 4.36181 0.276375L4 1H0.5C0.223875 1 0 1.22381 0 1.5V2.5C0 2.77613 0.223875 3 0.5 3H13.5C13.7762 3 14 2.77613 14 2.5V1.5C14 1.22381 13.7762 1 13.5 1Z",
    fill: "#328AC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.9f171c48020edaef53f0b1fddea74461.svg";
export { ForwardRef as ReactComponent };